import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionStaffFunctionEffects } from './competition-staff-function.effects'
import * as fromCompetitionStaffFunction from './competition-staff-function.reducer'
import { CompetitionStaffFunctionSerializer } from './competition-staff-function.serializer'
import { CompetitionStaffFunctionService } from './competition-staff-function.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionStaffFunction.FEATURE_NAME,
      fromCompetitionStaffFunction.competitionStaffFunctionReducer
    ),
    EffectsModule.forFeature([CompetitionStaffFunctionEffects])
  ],
  providers: [
    CompetitionStaffFunctionService,
    {
      provide: CompetitionStaffFunctionSerializer,
      useClass: CompetitionStaffFunctionSerializer
    }
  ],
  declarations: []
})
export class CompetitionStaffFunctionModule {}
